import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { withErrorBoundary, withSuspense, withTheme } from '@hocs'

export const createAppFromCommonTemplate = (
  node: HTMLElement | null,
  Component: JSX.Element,
): void => {
  if (!node) {
    return
  }

  const getComponent = () => Component
  const ComponentWrapper = pipe(
    getComponent,
    withSuspense,
    withErrorBoundary,
    withTheme,
  )

  ReactDOM.createRoot(node).render(<ComponentWrapper />)
}
